import * as React from "react";
import type { SVGProps } from "react";
const SvgMouse = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 7.8v2.4m0-7.8a6.13 6.13 0 0 0-4.243 1.687A5.65 5.65 0 0 0 6 8.16v7.68c0 1.528.632 2.993 1.757 4.073A6.13 6.13 0 0 0 12 21.6a6.13 6.13 0 0 0 4.243-1.687A5.65 5.65 0 0 0 18 15.84V8.16a5.65 5.65 0 0 0-1.757-4.073A6.13 6.13 0 0 0 12 2.4"
    />
  </svg>
);
export default SvgMouse;
